import { render, staticRenderFns } from "./EventOrderImgs.vue?vue&type=template&id=1e6e879f&scoped=true"
import script from "./EventOrderImgs.vue?vue&type=script&lang=js"
export * from "./EventOrderImgs.vue?vue&type=script&lang=js"
import style0 from "./EventOrderImgs.vue?vue&type=style&index=0&id=1e6e879f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6e879f",
  null
  
)

export default component.exports